var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccessDeniedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 209,
    height: 119,
    viewBox: "0 0 209 119",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5835 47.4727L7.95398 99.1162L1.21755 102.268L0.226053 106.856C0.226053 106.856 13.1964 111.797 30.6685 110.266C48.1407 108.736 54.8116 104.075 54.8116 104.075L54.7029 98.9328L43.9419 94.362L31.7865 47.6675C31.3267 45.8923 29.6416 44.6985 27.8105 44.8772C26.3035 45.0202 25.0454 46.0322 24.5835 47.4727Z",
    fill: "#E1EAFB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7974 104.072C54.7974 104.072 48.1152 108.715 30.6544 110.263C13.1822 111.794 0.211873 106.853 0.211873 106.853L1.20337 102.265L7.9542 99.1163C7.9542 99.1163 15.9822 102.463 27.399 101.212C38.8159 99.9602 43.939 94.3766 43.939 94.3766L54.7 98.9474L54.7974 104.072Z",
    fill: "#B9CCE7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.074 60.3347L14.9857 77.2454L9.84125 93.2424L38.7213 74.3327L35.074 60.3347Z",
    fill: "#B9CCE7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M80.1042 34.7739L92.7811 106.854",
    stroke: "#A9B1C2",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M53.6464 106.854L74.1413 0.814729L189.248 0.740936L207.918 106.854",
    stroke: "#ADB5BD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M189.249 0.740936L170.005 106.854",
    stroke: "#A9B1C2",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M74.1413 0.755707L67.5599 34.8477H183.065L189.248 0.755707H74.1413Z",
    fill: "#E1EAFB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M114.66 0.755707L78.9264 34.8477H67.5599L69.9157 22.6572L92.8694 0.755707H114.66Z",
    fill: "#B9CCE7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M158.241 0.755707L122.507 34.8477H100.717L136.45 0.755707H158.241Z",
    fill: "#B9CCE7"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M189.248 0.755707L186.628 15.2485L166.089 34.8477H144.298L180.032 0.755707H189.248Z",
    fill: "#B9CCE7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccessDeniedIcon);
export default __webpack_public_path__ + "static/media/access_denied_icon.c159e76b5df2bd6bd78b222efac5f72b.svg";
export { ForwardRef as ReactComponent };